import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 15}
    height={props.height || 15}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 17.125V7.22686C18.75 6.48124 18.1437 5.87499 17.3981 5.87499H13.75V1.33499C13.75 1.28124 13.7381 0.605614 13.1506 0.211864C12.5631 -0.181261 11.9338 0.0649888 11.8837 0.0849888L2.71188 3.86186C2.20375 4.07124 1.875 4.56124 1.875 5.11186V17.125H1.25C0.905 17.125 0.625 17.405 0.625 17.75C0.625 18.095 0.905 18.375 1.25 18.375H2.5H13.125H18.125H18.75C19.095 18.375 19.375 18.095 19.375 17.75C19.375 17.405 19.095 17.125 18.75 17.125ZM3.125 5.11186C3.125 5.07061 3.15 5.03374 3.18812 5.01811L12.36 1.24186C12.3944 1.22811 12.4256 1.23124 12.455 1.25124C12.485 1.27061 12.5 1.29874 12.5 1.33499V6.49999V17.125H3.125V5.11186ZM13.75 17.125V7.12499H17.3981C17.4544 7.12499 17.5 7.17061 17.5 7.22686V17.125H13.75Z"
      fill={ props.fill || "#4D5F7A" }
    />
    <path
      d="M9.375 14H6.25C5.905 14 5.625 14.28 5.625 14.625C5.625 14.97 5.905 15.25 6.25 15.25H9.375C9.72 15.25 10 14.97 10 14.625C10 14.28 9.72 14 9.375 14Z"
      fill={ props.fill || "#4D5F7A" }
    />
    <path
      d="M9.375 11.5H6.25C5.905 11.5 5.625 11.78 5.625 12.125C5.625 12.47 5.905 12.75 6.25 12.75H9.375C9.72 12.75 10 12.47 10 12.125C10 11.78 9.72 11.5 9.375 11.5Z"
      fill={ props.fill || "#4D5F7A" }
    />
    <path
      d="M9.375 9H6.25C5.905 9 5.625 9.28 5.625 9.625C5.625 9.97 5.905 10.25 6.25 10.25H9.375C9.72 10.25 10 9.97 10 9.625C10 9.28 9.72 9 9.375 9Z"
      fill={ props.fill || "#4D5F7A" }
    />
    <path
      d="M9.375 6.5H6.25C5.905 6.5 5.625 6.78 5.625 7.125C5.625 7.47 5.905 7.75 6.25 7.75H9.375C9.72 7.75 10 7.47 10 7.125C10 6.78 9.72 6.5 9.375 6.5Z"
      fill={ props.fill || "#4D5F7A" }
    />
  </svg>
);

export default SvgComponent;
